import React from 'react'
import whatsappLogo from '@/images/whatsapp-logo.png'

const WHATSAPP_NUMBER = '5511934297757'
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}`

export function WhatsappFloatingButton() {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Falar com atendimento do Cripto Alert no WhatsApp"
      className="fixed bottom-4 right-4 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition-transform hover:scale-105 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-[#25D366] focus-visible:ring-offset-background"
    >
      <img src={whatsappLogo as unknown as string} alt="WhatsApp" className="h-7 w-7" />
    </a>
  )
}
